import { useEffect, useState, useRef } from "react";
import { Link } from 'react-router-dom';
import {createClient} from "@sanity/client";
import useGridSize from '../../hooks/useGridSize'; // Adjust the import path as necessary

import styles from './MainPage.module.scss';


const MainPage = (props) => {

  // sanity config
  const PROJECT_ID = "spalbdrt";
  const DATASET = "production";
  const GROQ_QUERY = `*[_type == 'mainPage']{
  'backgroundImage': backgroundImage->{
    'url': image.asset->url
  },
  notes[]->,
  icons[]->{
    _id,
    position,
    zIndex,
    'url': icon.asset->url,
    slug,
    columnLengths
  },
  headerLink->{text, slug, _id, position}
}`;
  const URL = `https://${PROJECT_ID}.api.sanity.io/v2024-04-09/data/query/${DATASET}?query=${encodeURIComponent( GROQ_QUERY )}`;
  const client = createClient({
    projectId: PROJECT_ID,
    dataset: DATASET,
    useCdn: false,
    token:
      "skzQTck3oRJd3WhHhp7TvMesKTw6oOimx8R2bDEeKhNaaC1RoJ22z88VLnX53xNtAdMpo21yJHkhQoCRO4U73FlzRCIBdKbbjhD0r5KtK62REFUSMnn41gxlNTlUm37gocw1PTMzPNRZUMtksBIGE7vLwF8SpOzUK5FWSkbsJqxZZ303hCyE",
    apiVersion: "2024-04-10",
  });

  // Here was max   

  const [mainPageComponents, setMainPageComponents] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000)
  const [containerHeight, setContainerHeight] = useState(100);
  const mainRef = useRef(null);
  const gridSize = useGridSize();
  const isEditable = props.isEditable;


  //fetchign the main data
  useEffect(() => {
    fetch(URL)
      .then((res) => res.json())
      .then(({ result }) => {
        // console.log(result[0])
        setMainPageComponents(result[0]);
      })
      .catch((err) => console.error(err));
  }, [URL]);
  
  useEffect(() => {
    const documentHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty("--doc-height", `${window.innerHeight}px`);
      console.log(window.innerHeight);
    };

    window.addEventListener("resize", documentHeight);
    documentHeight();

    return () => {
      window.removeEventListener("resize", documentHeight);
    };
  }, [])

  //dragging
  useEffect(() => {
  let zIndexCounter = 1;

    if (isEditable && mainRef.current) {
      const boardElements = mainRef.current.children;
      Array.from(boardElements).forEach(element => {
        dragElement(element);
      })
    }

     function dragElement(elmnt) {
       let pos1 = 0,
         pos2 = 0,
         pos3 = 0,
         pos4 = 0;
       elmnt.onmousedown = dragMouseDown;

       function dragMouseDown(e) {
         e.preventDefault();

         zIndexCounter++;
         elmnt.style.zIndex = zIndexCounter;

         // get the mouse cursor position at startup:
         pos3 = e.clientX;
         pos4 = e.clientY;
         document.onmouseup = closeDragElement;
         // call a function whenever the cursor moves:
         document.onmousemove = elementDrag;
       }

       function elementDrag(e) {
         e.preventDefault();
         // calculate the new cursor position:
         pos1 = pos3 - e.clientX;
         pos2 = pos4 - e.clientY;
         pos3 = e.clientX;
         pos4 = e.clientY;
         // set the element's new position:
         const y = elmnt.offsetTop - pos2;
         const x = elmnt.offsetLeft - pos1;

         elmnt.style.left = x + "px";
         elmnt.style.top = y + "px";
       }

       function closeDragElement() {
         const objectSize = gridSize * 0.88;
         const x = parseInt(elmnt.style.left);
         const y = parseInt(elmnt.style.top);
         const insideGridX =
           Math.round(x / gridSize) * gridSize + (gridSize - objectSize) / 2;
         const insideGridY =
           Math.round(y / gridSize) * gridSize + (gridSize - objectSize) / 2;

         const crossGridX =
           Math.floor(x / gridSize) * gridSize + gridSize - objectSize / 2;
         const crossGridY =
           Math.floor(y / gridSize) * gridSize + gridSize - objectSize / 2;

         const snappedX =
           Math.abs(insideGridX - x) < Math.abs(crossGridX - x)
             ? insideGridX
             : crossGridX;
         const snappedY =
           Math.abs(insideGridY - y) < Math.abs(crossGridY - y)
             ? insideGridY
             : crossGridY;

         elmnt.style.left = snappedX + 20 + "px";
         elmnt.style.top = snappedY + 20 + "px";

         document.onmouseup = null;
         document.onmousemove = null;
       }
     }

  }, [isEditable, mainPageComponents, gridSize])


  useEffect(() => {
    const updateContainerHeight = () => {
      if (window.innerWidth < 1000) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
      const arrayOfPositionsY = [];
      mainRef.current &&
        Array.from(mainRef.current.children).forEach((element) => {
          const topCellCoordinate =
            Math.round((element.style.top.split("px")[0] / gridSize) * 2) / 2;
          arrayOfPositionsY.push(topCellCoordinate);
        });
      const lowestCoordinate =
        (Math.max(...arrayOfPositionsY) + 1) * gridSize - 2;
      // console.log(lowestCoordinate);
      setContainerHeight((lowestCoordinate / window.innerHeight) * 100);
    };

    if (!mainPageComponents) return; // If mainPageComponents is not yet available, do nothing

    // Execute the code after the elements are rendered
    updateContainerHeight();
    
    window.addEventListener("resize", updateContainerHeight);

    return () => {
      window.removeEventListener("resize", updateContainerHeight);
    };
  }, [mainPageComponents, gridSize]); 
  

  async function updateElementPosition(elementId, newPosition, zIndex) {
    try {
      const transaction = client.transaction();
      transaction.patch(elementId, {
        set: {
          position: newPosition, 
          zIndex: zIndex,
        },
      });
      await transaction.commit();
      console.log("Element position updated in Sanity CMS");
    } catch (error) {
      console.error("Failed to update element position in Sanity CMS", error);
    }
  }
 
  const savePositions = () => {
    Array.from(mainRef.current.children).forEach(element => {
      const elementId = element.getAttribute('data-id');
      const topCellCoordinate = Math.round((element.style.top.split("px")[0]-20) / gridSize * 2) / 2;
      const leftCellCoordinate = Math.round((element.style.left.split("px")[0]-20) / gridSize * 2) / 2;
      const zIndex = element.style.zIndex || 0;
      updateElementPosition(elementId, `${topCellCoordinate};${leftCellCoordinate}`, zIndex);
    })
  }

  return (
    <>
      {mainPageComponents && (
        <>
          <main
            className={styles.main}
            ref={mainRef}
            style={{
              backgroundSize: gridSize + "px " + gridSize + "px",
              height: containerHeight + "vh",
              // height: 100 + "vh",
              width: isMobile ? 8.2 * gridSize : "auto",
              fontSize: (gridSize * 6 + 0.24 * gridSize + gridSize) / 16 + "%",
            }}
          >
            {/* header link */}
            <div
              className={`${styles.note} ${styles.headerLink}`}
              key={mainPageComponents.headerLink._id}
              data-id={mainPageComponents.headerLink._id}
              style={{
                // top: mainPageComponents.headerLink.position.split(";")[0] * gridSize + 0.06 * gridSize + 20,
                top: 0,
                left:
                  mainPageComponents.headerLink.position.split(";")[1] *
                    gridSize +
                  0.06 * gridSize +
                  20,
                width: gridSize * 0.76,
                // height: gridSize * 0.88,
                paddingLeft: 0.06 * gridSize,
                paddingRight: 0.06 * gridSize,
                zIndex: mainPageComponents.headerLink.zIndex,
              }}
            >
              <Link to="/info">{mainPageComponents.headerLink.text}</Link>
            </div>

            {/* icons */}
            {mainPageComponents.icons.map((icon) => {
              const topPosition =
                icon.position !== null
                  ? icon.position.split(";")[0] * gridSize + 0.06 * gridSize
                  : 0;
              const leftPosition =
                icon.position !== null
                  ? icon.position.split(";")[1] * gridSize + 0.06 * gridSize
                  : 0;
              return isEditable ? (
                <div
                  key={icon._id}
                  className={styles.icon}
                  style={{
                    top: topPosition + 20,
                    left: leftPosition + 20,
                    width: gridSize * 0.88,
                    height: gridSize * 0.88,
                    zIndex: icon.zIndex !== null ? icon.zIndex : 0,
                  }}
                  data-id={icon._id}
                >
                  <img src={icon.url} alt=""></img>
                </div>
              ) : (
                <Link
                  to={icon.slug}
                  key={icon._id}
                  className={styles.icon}
                  data-id={icon._id}
                  style={{
                    top: topPosition + 20,
                    left: leftPosition + 20,
                    width: gridSize * 0.88,
                    height: gridSize * 0.88,
                    cursor: "pointer",
                    zIndex: icon.zIndex !== null ? icon.zIndex : 0,
                  }}
                  title={icon.slug}
                >
                  <img src={icon.url} alt=""></img>
                </Link>
              );
            })}

            {/* notes */}
            {mainPageComponents.notes.map((note) => {
              const topPosition =
                note.position !== null
                  ? note.position.split(";")[0] * gridSize + 0.06 * gridSize
                  : 0;
              const leftPosition =
                note.position !== null
                  ? note.position.split(";")[1] * gridSize + 0.06 * gridSize
                  : 0;
              const noteWidth = +note.columnLengths * gridSize;
              return (
                <div
                  key={note._id}
                  data-id={note._id}
                  className={styles.note}
                  style={{
                    top: topPosition + 20,
                    left: leftPosition + 20,
                    // width: gridSize * 0.88 - 0.06 * gridSize,
                    width: noteWidth - 0.12 * gridSize - 0.06 * gridSize,
                    // height: gridSize * 0.88,
                    paddingTop: 0.03 * gridSize,
                    paddingRight: 0.03 * gridSize,
                    paddingLeft: 0.03 * gridSize,
                    zIndex: note.zIndex !== null ? note.zIndex : 0,
                  }}
                >
                  {note.text}
                </div>
              );
            })}
          </main>
          <div
            className={styles.backgroundImageContainer}
            style={{
              height: containerHeight + "vh",
              // height: 100 + "vh",
              width: isMobile ? 8.2 * gridSize : "auto",
            }}
          >
            <img
              src={mainPageComponents.backgroundImage.url}
              alt="background"
            ></img>
          </div>
        </>
      )}
      {isEditable && (
        <button className={styles.saveButton} onClick={savePositions}>
          Save position
        </button>
      )}
    </>
  );
}

export default MainPage;